import React from 'react';

import styled from '@emotion/styled';

import { COLORS, Text } from '@clutter/clean';

import { Spacer } from '@shared/components/helpers';

import { AppointmentHubQuery, UpcomingSubscriptionSetFragment } from '@portal/schema';

import { AppointmentDetailsButtons } from './buttons';
import { OrderAppointmentDetailsHeader } from './header';
import { OrderAppointmentDetailsInfoList } from './info_list';
import { LongDistanceMoveInfoList } from './info_list/long_distance_move_info_list';
import { LongDistanceMoveStatusTracker } from './long_distance_move_status_tracker';

export type AppointmentDetailsOrder = AppointmentHubQuery['order'];

const FinePrint = styled(Text.Caption)`
  text-align: center;
  color: ${COLORS.storm};
`;

export const AppointmentDetails: React.FC<{
  upcomingSubscriptionSet: UpcomingSubscriptionSetFragment;
  order: AppointmentDetailsOrder;
  refetchData: () => void;
}> = ({ upcomingSubscriptionSet, order, refetchData }) => {
  const isLongDistanceOrder = !!order.movingOperation?.longDistanceTransportationRate;
  const travelRateMultiplier =
    order.movingOperation?.movingConfiguration && !isLongDistanceOrder
      ? order.movingOperation.movingConfiguration.travelRateMultiplier
      : 1;
  return (
    <>
      {order.longDistanceMove ? (
        <>
          <LongDistanceMoveStatusTracker order={order} />
          <LongDistanceMoveInfoList order={order} />
        </>
      ) : (
        <>
          <OrderAppointmentDetailsHeader sourceOrder={order} />
          <Spacer height="16px" />
          <OrderAppointmentDetailsInfoList
            order={order}
            upcomingSubscriptionSet={upcomingSubscriptionSet}
            refetchData={refetchData}
          />
          <Spacer height="16px" />
          <AppointmentDetailsButtons order={order} />
          {travelRateMultiplier === 2 && (
            <>
              <Spacer height="16px" />
              <FinePrint>
                State law requires us to charge for double the drive time to transport your items between locations.
                This protects our customers, by keeping prices low and not charging our customers for drives between our
                warehouses and your home.
              </FinePrint>
            </>
          )}
        </>
      )}
    </>
  );
};
